<template>
  <el-form-item
    :label="form.name"
    :prop="form.model"
    :class="[form.options.required ? 'label-blue' : '']"
    :rules="form.rules"
    :required="form.options.required"
    v-show="!form.options.hidden"
  >
    <el-upload
      class="upload-demo"
      ref="upload"
      :action="uploadUrl"
      accept="image/*"
      :on-preview="handlePreview"
      :before-upload="beforeAvatarUpload"
      :before-remove="beforeRemove"
      list-type="picture"
      multiple
      :on-success="successHandle"
      :limit="form.options.limit"
      :on-exceed="handleExceed"
      :auto-upload="false"
      :file-list="fileList"
    >
      <el-button
        slot="trigger"
        size="small"
        icon="el-icon-plus"
        type="primary"
        :disabled="inputDisable"
        >选取照片</el-button
      >
      <el-button
        style="margin-left: 10px"
        size="small"
        type="success"
        :disabled="inputDisable"
        @click="submitUpload"
        >上传到服务器</el-button
      >
      <div slot="tip" class="el-upload__tip">{{ form.options.tip }}</div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-form-item>
</template>

<script>
export default {
  name: "DynamicImgUpload",
  data() {
    return {
      key: "",
      formData: {},
      mainValue: "",
      uploadUrl: "",
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: [],
    };
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          options: {
            defaultValue: [],
            width: "",
            tip: "只能上传jpg/png文件，且不超过500kb",
            action: "https://jsonplaceholder.typicode.com/photos/",
            customClass: "",
            disabled: false,
            limit: 9,
            fileList: [],
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,
            remoteFunc: "func_1573098714232",
          },
          name: "文件",
          novalid: {},
          key: "1573098714232",
          model: "fileupload_1573098714232",
          rules: [],
        };
      },
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val;
      },
    },
  },
  methods: {
    onInput() {
      let that = this;
      that.$emit("input", that.value, that.form.model);
      if (typeof that.form.options.changeFunc === "function") {
        // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms);
      }
    },
    //验证是否是图片
    beforeAvatarUpload(file) {
      var isImg;
      var imgType = file.name.substring(file.name.lastIndexOf(".") + 1);
      switch (imgType) {
        case "jpg":
          isImg = true;
          break;
        case "png":
          isImg = true;
          break;
        default:
          isImg = false;
      }
      if (!isImg) {
        this.$message.error(this.form.options.tip);
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isImg && isLt2M;
    },
    //上传到服务器
    submitUpload() {
      this.$refs.upload.submit();
    },
    //上传成功回调
    successHandle(response, file, fileList) {},
    //选择查看
    handlePreview(file) {
      if (this.beforeAvatarUpload(file)) {
        this.dialogVisible = true;
        this.dialogImageUrl = file.url;
      }
    },
    //验证文件最多数量
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.form.options.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${fileList.length} 个文件`
      );
    },
    //删除
    beforeRemove(file, fileList) {
      if (this.inputDisable) {
        this.$message.error("查看状态下无法删除照片");
        return false;
      } else {
        return this.$confirm(`确定移除 ${file.name}？`);
      }
    },
  },
  created() {
    let that = this;
    that.key = that.form.key;
    if (that.form.hasOwnProperty("options")) {
      that.value[that.form.model] =
        that.value[that.form.model] || this.form["options"]["defaultValue"] || "";
    }
    this.uploadUrl = this.$url.uploadfiles;
  },
  mounted() {
    let that = this;
    that.$emit("init", that.key, that);
  },
  computed: {
    inputDisable() {
      return this.disabled || this.form.options.disabled;
    },
  },
};
</script>

<style scoped></style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicImgUpload.vue"
}
</vue-filename-injector>
